export const meta = (state = {}, { type, payload }) => {
  switch (type) {
    case 'META/RECEIVE':
      return { ...state, ...payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/meta.js